"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CalendarContext = _interopRequireDefault(require("../CalendarContext"));

var _date = require("../util/date");

var _classnames = _interopRequireDefault(require("../util/classnames"));

var _TBody = _interopRequireDefault(require("./TBody"));

var _useCls = _interopRequireDefault(require("../useCls"));

var _getChangedValue = _interopRequireDefault(require("./getChangedValue"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var C_COL = 3;
var C_ROW = 4;

var DecadePanel = function DecadePanel(_ref) {
  var now = _ref.now,
      value = _ref.value,
      onChange = _ref.onChange,
      current = _ref.current,
      onCurrentChange = _ref.onCurrentChange,
      disabledDecade = _ref.disabledDecade;
  var baseYear = (0, _react.useMemo)(function () {
    return (current.getFullYear() / 100 | 0) * 100;
  }, [current]);
  var valueYear = (0, _react.useMemo)(function () {
    return value === null || value === void 0 ? void 0 : value.getFullYear();
  }, [value]);
  var nowYear = (0, _react.useMemo)(function () {
    return now === null || now === void 0 ? void 0 : now.getFullYear();
  }, [now]);

  var _useContext = (0, _react.useContext)(_CalendarContext.default),
      onlyValidDecade = _useContext.onlyValidDecade,
      onChangeWhenPrevNextClick = _useContext.onChangeWhenPrevNextClick,
      disabledPrevNextClickWhenDisabled = _useContext.disabledPrevNextClickWhenDisabled;

  var cls = (0, _useCls.default)(); // use ref to reduce reRender

  var currentRef = (0, _react.useRef)(current);
  var valueRef = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    currentRef.current = current;
    valueRef.current = value;
  }, [current, value]);
  var cells = (0, _react.useMemo)(function () {
    var cells = [];
    var start = onlyValidDecade ? 0 : -1;
    var end = (onlyValidDecade ? 10 : C_COL * C_ROW) + start;

    for (var i = start; i < end; i++) {
      var year = baseYear + i * 10;
      var latestYear = year + 9;
      var active = valueYear !== undefined && valueYear >= year && valueYear <= latestYear;
      var isNow = nowYear !== undefined && nowYear >= year && nowYear <= latestYear;
      var disabled = disabledDecade === null || disabledDecade === void 0 ? void 0 : disabledDecade((0, _date.set)(current, year, 'year'), value);
      var isCurrent = i < 0 ? 'prev' : i > 9 ? 'next' : 'current';
      var cellInfo = {
        children: year + '-' + latestYear,
        current: isCurrent,
        disabled: disabled,
        year: year,
        className: (0, _classnames.default)(active && cls.active, isNow && cls.now, disabled && cls.disabled, isCurrent === 'prev' && cls.prev, isCurrent === 'next' && cls.next)
      };
      cells.push(cellInfo);
    }

    return cells;
  }, [onlyValidDecade, baseYear, valueYear, nowYear, disabledDecade, current, value, cls]);
  var onYearClick = (0, _react.useCallback)(function (index) {
    var cellInfo = cells[index];
    if (!cellInfo) return;
    if (cellInfo.disabled && disabledPrevNextClickWhenDisabled) return;

    if (cellInfo.current === 'prev') {
      onCurrentChange((0, _date.set)(current, baseYear - 100, 'year'));
    } else if (cellInfo.current === 'next') {
      onCurrentChange((0, _date.set)(current, baseYear + 100, 'year'));
    }

    if (cellInfo.disabled) return;

    if (cellInfo.current === 'current' || onChangeWhenPrevNextClick) {
      var changedValue = (0, _getChangedValue.default)({
        year: cellInfo.year
      }, currentRef.current, valueRef.current);
      onChange(changedValue);
    }
  }, [baseYear, cells, current, disabledPrevNextClickWhenDisabled, onChange, onChangeWhenPrevNextClick, onCurrentChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls.table
  }, /*#__PURE__*/_react.default.createElement(_TBody.default, {
    cells: cells,
    onCellClick: onYearClick,
    col: C_COL,
    row: C_ROW,
    mode: "decade"
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(DecadePanel);

exports.default = _default;